// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Основные стили */
.document-section {
  background: transparent;
  padding: 0;
  overflow: hidden;
  min-height: 65vh;
}

.ds-header {
  background: transparent;
  margin-bottom: 24px;
  padding: 0 8px;
}

/* Контролы документов */
.ds-controls {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 20px;
  flex-wrap: wrap;
}

.ds-controls-left {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1 1;
  min-width: 300px;
}

.ds-controls-right {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.ds-filter-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1 1;
  min-width: 300px;
}

.ds-filter-label {
  color: #002FA7;
  font-weight: 600;
  font-size: 14px;
}

/* Общие стили для инпутов, селектов и текстэреа */
.ds-select,
.ds-input,
.ds-textarea {
  padding: 12px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  font-size: 14px;
  color: #1e293b;
  background: white;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: inherit;
}

.ds-select:focus,
.ds-input:focus,
.ds-textarea:focus {
  outline: none;
  border-color: #5986f7;
  box-shadow: 0 0 0 4px rgba(89, 134, 247, 0.15);
  transform: translateY(-1px);
}

.ds-select:disabled,
.ds-input.disabled,
.ds-input:disabled {
  background: #f8fafc;
  color: #64748b;
  border-color: #d1d5db;
  cursor: not-allowed;
}

.ds-input:required:not(.disabled):not(:disabled) {
  border-left: 4px solid #5986f7;
}

.ds-input:invalid:not(:focus):not(.disabled):not(:disabled) {
  border-color: #fca5a5;
}

.ds-input::placeholder,
.ds-textarea::placeholder {
  color: #9ca3af;
}

.ds-textarea {
  resize: vertical;
  min-height: 80px;
}

/* Сообщения об ошибках и информации */
.ds-error-message {
  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
  border: 1px solid #fca5a5;
  color: #dc2626;
  padding: 16px;
  border-radius: 12px;
  margin-bottom: 24px;
  font-weight: 500;
  border-left: 4px solid #ef4444;
}

.ds-cache-info {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #10b981;
  margin-top: 5px;
}

.ds-offline-indicator {
  background: #fef3c7;
  border: 1px solid #f59e0b;
  border-radius: 4px;
  padding: 8px 12px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #92400e;
}

.ds-offline-text {
  font-size: 12px;
  color: #92400e;
}

.ds-pending-documents {
  background: #dbeafe;
  border: 1px solid #3b82f6;
  border-radius: 4px;
  padding: 8px 12px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #1e40af;
}

/* Контент */
.ds-content {
  padding: 8px 0;
}

/* Загрузка */
.ds-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 50vh;
  color: #002FA7;
}

.ds-loading-spinner {
  width: 50px;
  height: 50px;
  border: 4px solid rgba(0, 47, 167, 0.3);
  border-left: 4px solid #002FA7;
  border-radius: 50%;
  animation: ds-spin 1s linear infinite;
  margin-bottom: 20px;
}

@keyframes ds-spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.ds-loading p {
  font-size: 18px;
  margin: 0;
}

/* Кнопка обновления */
.ds-refresh-btn {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border: 1px solid #e2e8f0;
  color: #374151;
  padding: 10px 20px;
  border-radius: 10px;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  gap: 10px;
  white-space: nowrap;
  height: fit-content;
}

.ds-refresh-btn:hover:not(:disabled) {
  background: #f8fafc;
  border-color: #cbd5e1;
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.12);
  color: #002FA7;
}

.ds-refresh-btn:disabled {
  background: #f1f5f9;
  border-color: #d1d5db;
  color: #9ca3af;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.ds-refresh-icon {
  width: 22px;
  height: 22px;
  transition: transform 0.3s ease;
}

.ds-refresh-spin {
  animation: ds-spin 1s linear infinite;
}

/* Кнопки создания документа */
.ds-create-main-btn,
.ds-create-btn {
  background: #002FA7;
  color: white;
  border: none;
  font-weight: 600;
  font-size: 14px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 47, 167, 0.3);
  position: relative;
  overflow: hidden;
}

.ds-create-main-btn {
  padding: 12px 24px;
  border-radius: 8px;
  min-width: 180px;
}

.ds-create-btn {
  padding: 12px 32px;
  border-radius: 12px;
}

.ds-create-main-btn:hover:not(:disabled),
.ds-create-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 47, 167, 0.5);
}

.ds-create-main-btn:disabled,
.ds-create-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Таблица документов */
.ds-table {
  width: 100%;
  border-collapse: collapse;
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.ds-table th {
  background: rgba(0, 47, 167, 0.05);
  padding: 20px;
  text-align: left;
  font-weight: 600;
  color: #4a5568;
  border-bottom: 1px solid #e2e8f0;
  font-size: 14px;
}

.ds-table td {
  padding: 16px 20px;
  border-bottom: 1px solid #f1f5f9;
  color: #1e293b;
  font-size: 14px;
}

.ds-table tr:hover {
  background: rgba(0, 47, 167, 0.02);
}

.ds-table tr:last-child td {
  border-bottom: none;
}

/* Кнопки действий */
.ds-action-buttons {
  display: flex;
  gap: 8px;
  align-items: center;
}

.ds-download-btn,
.ds-delete-btn {
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 500;
  font-size: 12px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.ds-download-btn {
  background: linear-gradient(135deg, #10b981 0%, #34d399 100%);
}

.ds-download-btn:hover {
  background: linear-gradient(135deg, #059669 0%, #10b981 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
}

.ds-delete-btn {
  background: linear-gradient(135deg, #ef4444 0%, #f87171 100%);
}

.ds-delete-btn:hover {
  background: linear-gradient(135deg, #dc2626 0%, #ef4444 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);
}

.ds-download-btn:disabled,
.ds-delete-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

/* Состояние пустого списка */
.ds-empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #64748b;
  background: rgba(238, 238, 238, 0.188);
  border-radius: 16px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  border: 1px solid #64748b4b;
}

.ds-empty-state p {
  font-size: 16px;
  margin: 0;
  font-weight: 500;
}

/* Модальное окно */
.ds-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(50, 64, 124, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(8px);
  animation: ds-modal-fade-in 0.3s ease;
}

@keyframes ds-modal-fade-in {
  from { opacity: 0; }
  to { opacity: 1; }
}

.ds-modal-container {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 20px;
  padding: 0;
  width: 90%;
  max-width: 800px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  animation: ds-modal-slide-up 0.3s ease;
  border: 1px solid #e2e8f0;
}

@keyframes ds-modal-slide-up {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.ds-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 28px 28px 20px;
  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);
  border-radius: 20px 20px 0 0;
  color: white;
  position: relative;
}

.ds-modal-header::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 28px;
  right: 28px;
  height: 2px;
  background: rgba(255, 255, 255, 0.3);
}

.ds-modal-header h3 {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: white;
}

.ds-modal-close {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: white;
  padding: 6px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
}

.ds-modal-close:hover {
  background: rgba(255, 255, 255, 0.3);
}

.ds-modal-content {
  padding: 28px;
}

.ds-modal-type {
  background: linear-gradient(135deg, #f0f2ff 0%, #e0e7fe 100%);
  border-radius: 12px;
  padding: 16px 20px;
  margin-bottom: 24px;
  color: #002FA7;
  font-weight: 400;
  border-left: 4px solid #2d50a8;
}

/* Секции формы */
.ds-form-sections {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.ds-form-section {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.ds-form-section:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.ds-form-section h4 {
  color: #002FA7;
  font-size: 16px;
  font-weight: 700;
  margin: 0 0 20px 0;
  padding-bottom: 12px;
  border-bottom: 2px solid #f1f5f9;
}

.ds-form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 16px;
  margin-bottom: 16px;
}

.ds-form-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.ds-form-field.full-width {
  grid-column: 1 / -1;
}

.ds-form-field label {
  color: #374151;
  font-size: 14px;
  font-weight: 600;
}

.ds-form-field:focus-within label {
  color: #002FA7;
}

.ds-form-field label::after {
  content: " *";
  color: #ef4444;
  font-weight: bold;
}

/* Футер модального окна */
.ds-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid #f1f5f9;
}

.ds-cancel-btn {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  border: 1px solid #cbd5e1;
  color: #475569;
  padding: 12px 24px;
  border-radius: 12px;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  transition: all 0.3s ease;
}

.ds-cancel-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #f8fafc 0%, #dde2e8 100%);
  color: #002FA7;
  transform: translateY(-1px);
}

.ds-cancel-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.ds-sync-button {
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 3px;
  padding: 2px 8px;
  font-size: 12px;
  cursor: pointer;
}

.ds-sync-button:disabled {
  background: #9ca3af;
  cursor: not-allowed;
}

/* Адаптивность */
@media (max-width: 1024px) {
  .ds-modal-container {
    width: 95%;
    max-width: 700px;
  }
  
  .ds-form-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .ds-controls {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
  }
  
  .ds-filter-section {
    min-width: auto;
  }
  
  .ds-create-main-btn {
    width: 100%;
    text-align: center;
  }
  
  .ds-table {
    display: block;
    overflow-x: auto;
  }
  
  .ds-action-buttons {
    flex-direction: column;
    gap: 6px;
  }
  
  .ds-download-btn,
  .ds-delete-btn {
    width: 100%;
    text-align: center;
  }
  
  .ds-modal-container {
    width: 98%;
    margin: 10px;
  }
  
  .ds-modal-header {
    padding: 20px 20px 16px;
  }
  
  .ds-modal-content {
    padding: 20px;
  }
  
  .ds-form-section {
    padding: 16px;
  }
  
  .ds-modal-footer {
    flex-direction: column;
    gap: 12px;
  }
  
  .ds-cancel-btn,
  .ds-create-btn {
    width: 100%;
    text-align: center;
  }
}

@media (max-width: 480px) {
  .ds-table th,
  .ds-table td {
    padding: 12px 8px;
    font-size: 12px;
  }
  
  .ds-modal-header h3 {
    font-size: 18px;
  }
  
  .ds-form-section h4 {
    font-size: 14px;
  }
  
  .ds-input,
  .ds-textarea,
  .ds-select {
    padding: 10px 12px;
    font-size: 13px;
  }
}

/* Улучшенная доступность */
@media (prefers-reduced-motion: reduce) {
  .ds-create-main-btn,
  .ds-create-btn,
  .ds-download-btn,
  .ds-delete-btn,
  .ds-modal-close,
  .ds-cancel-btn,
  .ds-refresh-btn,
  .ds-input,
  .ds-textarea,
  .ds-select,
  .ds-form-section,
  .ds-modal-container,
  .ds-modal-overlay {
    transition: none;
    animation: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/st-components/DocumentSectionStyle.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,uBAAuB;EACvB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA,kDAAkD;AAClD;;;EAGE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;;;EAGE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,sCAAsC;AACtC;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,cAAc;AAChB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,8BAA8B;EAC9B,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,qCAAqC;AACvC;;AAEA,8BAA8B;AAC9B;;EAEE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,iFAAiF;AACnF;;AAEA;EACE,kCAAkC;EAClC,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,sCAAsC;EACtC,mBAAmB;EACnB,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,UAAU;EACV,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,iDAAiD;EACjD,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;EAC7D,4BAA4B;EAC5B,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;;IAEE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;;IAEE,WAAW;IACX,kBAAkB;EACpB;AACF;;AAEA;EACE;;IAEE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;IAGE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA,2BAA2B;AAC3B;EACE;;;;;;;;;;;;;IAaE,gBAAgB;IAChB,eAAe;EACjB;AACF","sourcesContent":["/* Основные стили */\n.document-section {\n  background: transparent;\n  padding: 0;\n  overflow: hidden;\n  min-height: 65vh;\n}\n\n.ds-header {\n  background: transparent;\n  margin-bottom: 24px;\n  padding: 0 8px;\n}\n\n/* Контролы документов */\n.ds-controls {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  gap: 20px;\n  flex-wrap: wrap;\n}\n\n.ds-controls-left {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  flex: 1;\n  min-width: 300px;\n}\n\n.ds-controls-right {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.ds-filter-section {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  flex: 1;\n  min-width: 300px;\n}\n\n.ds-filter-label {\n  color: #002FA7;\n  font-weight: 600;\n  font-size: 14px;\n}\n\n/* Общие стили для инпутов, селектов и текстэреа */\n.ds-select,\n.ds-input,\n.ds-textarea {\n  padding: 12px 16px;\n  border: 2px solid #e2e8f0;\n  border-radius: 10px;\n  font-size: 14px;\n  color: #1e293b;\n  background: white;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-family: inherit;\n}\n\n.ds-select:focus,\n.ds-input:focus,\n.ds-textarea:focus {\n  outline: none;\n  border-color: #5986f7;\n  box-shadow: 0 0 0 4px rgba(89, 134, 247, 0.15);\n  transform: translateY(-1px);\n}\n\n.ds-select:disabled,\n.ds-input.disabled,\n.ds-input:disabled {\n  background: #f8fafc;\n  color: #64748b;\n  border-color: #d1d5db;\n  cursor: not-allowed;\n}\n\n.ds-input:required:not(.disabled):not(:disabled) {\n  border-left: 4px solid #5986f7;\n}\n\n.ds-input:invalid:not(:focus):not(.disabled):not(:disabled) {\n  border-color: #fca5a5;\n}\n\n.ds-input::placeholder,\n.ds-textarea::placeholder {\n  color: #9ca3af;\n}\n\n.ds-textarea {\n  resize: vertical;\n  min-height: 80px;\n}\n\n/* Сообщения об ошибках и информации */\n.ds-error-message {\n  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);\n  border: 1px solid #fca5a5;\n  color: #dc2626;\n  padding: 16px;\n  border-radius: 12px;\n  margin-bottom: 24px;\n  font-weight: 500;\n  border-left: 4px solid #ef4444;\n}\n\n.ds-cache-info {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n  color: #10b981;\n  margin-top: 5px;\n}\n\n.ds-offline-indicator {\n  background: #fef3c7;\n  border: 1px solid #f59e0b;\n  border-radius: 4px;\n  padding: 8px 12px;\n  margin-bottom: 10px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #92400e;\n}\n\n.ds-offline-text {\n  font-size: 12px;\n  color: #92400e;\n}\n\n.ds-pending-documents {\n  background: #dbeafe;\n  border: 1px solid #3b82f6;\n  border-radius: 4px;\n  padding: 8px 12px;\n  margin-bottom: 10px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #1e40af;\n}\n\n/* Контент */\n.ds-content {\n  padding: 8px 0;\n}\n\n/* Загрузка */\n.ds-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 50vh;\n  color: #002FA7;\n}\n\n.ds-loading-spinner {\n  width: 50px;\n  height: 50px;\n  border: 4px solid rgba(0, 47, 167, 0.3);\n  border-left: 4px solid #002FA7;\n  border-radius: 50%;\n  animation: ds-spin 1s linear infinite;\n  margin-bottom: 20px;\n}\n\n@keyframes ds-spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n.ds-loading p {\n  font-size: 18px;\n  margin: 0;\n}\n\n/* Кнопка обновления */\n.ds-refresh-btn {\n  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\n  border: 1px solid #e2e8f0;\n  color: #374151;\n  padding: 10px 20px;\n  border-radius: 10px;\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 14px;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  white-space: nowrap;\n  height: fit-content;\n}\n\n.ds-refresh-btn:hover:not(:disabled) {\n  background: #f8fafc;\n  border-color: #cbd5e1;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.12);\n  color: #002FA7;\n}\n\n.ds-refresh-btn:disabled {\n  background: #f1f5f9;\n  border-color: #d1d5db;\n  color: #9ca3af;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.ds-refresh-icon {\n  width: 22px;\n  height: 22px;\n  transition: transform 0.3s ease;\n}\n\n.ds-refresh-spin {\n  animation: ds-spin 1s linear infinite;\n}\n\n/* Кнопки создания документа */\n.ds-create-main-btn,\n.ds-create-btn {\n  background: #002FA7;\n  color: white;\n  border: none;\n  font-weight: 600;\n  font-size: 14px;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 15px rgba(0, 47, 167, 0.3);\n  position: relative;\n  overflow: hidden;\n}\n\n.ds-create-main-btn {\n  padding: 12px 24px;\n  border-radius: 8px;\n  min-width: 180px;\n}\n\n.ds-create-btn {\n  padding: 12px 32px;\n  border-radius: 12px;\n}\n\n.ds-create-main-btn:hover:not(:disabled),\n.ds-create-btn:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(0, 47, 167, 0.5);\n}\n\n.ds-create-main-btn:disabled,\n.ds-create-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Таблица документов */\n.ds-table {\n  width: 100%;\n  border-collapse: collapse;\n  background: white;\n  border-radius: 16px;\n  overflow: hidden;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n}\n\n.ds-table th {\n  background: rgba(0, 47, 167, 0.05);\n  padding: 20px;\n  text-align: left;\n  font-weight: 600;\n  color: #4a5568;\n  border-bottom: 1px solid #e2e8f0;\n  font-size: 14px;\n}\n\n.ds-table td {\n  padding: 16px 20px;\n  border-bottom: 1px solid #f1f5f9;\n  color: #1e293b;\n  font-size: 14px;\n}\n\n.ds-table tr:hover {\n  background: rgba(0, 47, 167, 0.02);\n}\n\n.ds-table tr:last-child td {\n  border-bottom: none;\n}\n\n/* Кнопки действий */\n.ds-action-buttons {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.ds-download-btn,\n.ds-delete-btn {\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 12px;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n}\n\n.ds-download-btn {\n  background: linear-gradient(135deg, #10b981 0%, #34d399 100%);\n}\n\n.ds-download-btn:hover {\n  background: linear-gradient(135deg, #059669 0%, #10b981 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);\n}\n\n.ds-delete-btn {\n  background: linear-gradient(135deg, #ef4444 0%, #f87171 100%);\n}\n\n.ds-delete-btn:hover {\n  background: linear-gradient(135deg, #dc2626 0%, #ef4444 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);\n}\n\n.ds-download-btn:disabled,\n.ds-delete-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* Состояние пустого списка */\n.ds-empty-state {\n  text-align: center;\n  padding: 60px 20px;\n  color: #64748b;\n  background: rgba(238, 238, 238, 0.188);\n  border-radius: 16px;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n  border: 1px solid #64748b4b;\n}\n\n.ds-empty-state p {\n  font-size: 16px;\n  margin: 0;\n  font-weight: 500;\n}\n\n/* Модальное окно */\n.ds-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(50, 64, 124, 0.3);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  backdrop-filter: blur(8px);\n  animation: ds-modal-fade-in 0.3s ease;\n}\n\n@keyframes ds-modal-fade-in {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.ds-modal-container {\n  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\n  border-radius: 20px;\n  padding: 0;\n  width: 90%;\n  max-width: 800px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  animation: ds-modal-slide-up 0.3s ease;\n  border: 1px solid #e2e8f0;\n}\n\n@keyframes ds-modal-slide-up {\n  from {\n    opacity: 0;\n    transform: translateY(20px) scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.ds-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 28px 28px 20px;\n  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);\n  border-radius: 20px 20px 0 0;\n  color: white;\n  position: relative;\n}\n\n.ds-modal-header::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 28px;\n  right: 28px;\n  height: 2px;\n  background: rgba(255, 255, 255, 0.3);\n}\n\n.ds-modal-header h3 {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 700;\n  color: white;\n}\n\n.ds-modal-close {\n  background: rgba(255, 255, 255, 0.2);\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: white;\n  padding: 6px;\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 10px;\n  transition: all 0.3s ease;\n  backdrop-filter: blur(10px);\n}\n\n.ds-modal-close:hover {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n.ds-modal-content {\n  padding: 28px;\n}\n\n.ds-modal-type {\n  background: linear-gradient(135deg, #f0f2ff 0%, #e0e7fe 100%);\n  border-radius: 12px;\n  padding: 16px 20px;\n  margin-bottom: 24px;\n  color: #002FA7;\n  font-weight: 400;\n  border-left: 4px solid #2d50a8;\n}\n\n/* Секции формы */\n.ds-form-sections {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.ds-form-section {\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 16px;\n  padding: 24px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n  transition: all 0.3s ease;\n}\n\n.ds-form-section:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.ds-form-section h4 {\n  color: #002FA7;\n  font-size: 16px;\n  font-weight: 700;\n  margin: 0 0 20px 0;\n  padding-bottom: 12px;\n  border-bottom: 2px solid #f1f5f9;\n}\n\n.ds-form-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.ds-form-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.ds-form-field.full-width {\n  grid-column: 1 / -1;\n}\n\n.ds-form-field label {\n  color: #374151;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.ds-form-field:focus-within label {\n  color: #002FA7;\n}\n\n.ds-form-field label::after {\n  content: \" *\";\n  color: #ef4444;\n  font-weight: bold;\n}\n\n/* Футер модального окна */\n.ds-modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 16px;\n  margin-top: 32px;\n  padding-top: 24px;\n  border-top: 1px solid #f1f5f9;\n}\n\n.ds-cancel-btn {\n  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);\n  border: 1px solid #cbd5e1;\n  color: #475569;\n  padding: 12px 24px;\n  border-radius: 12px;\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 14px;\n  transition: all 0.3s ease;\n}\n\n.ds-cancel-btn:hover:not(:disabled) {\n  background: linear-gradient(135deg, #f8fafc 0%, #dde2e8 100%);\n  color: #002FA7;\n  transform: translateY(-1px);\n}\n\n.ds-cancel-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.ds-sync-button {\n  background: #3b82f6;\n  color: white;\n  border: none;\n  border-radius: 3px;\n  padding: 2px 8px;\n  font-size: 12px;\n  cursor: pointer;\n}\n\n.ds-sync-button:disabled {\n  background: #9ca3af;\n  cursor: not-allowed;\n}\n\n/* Адаптивность */\n@media (max-width: 1024px) {\n  .ds-modal-container {\n    width: 95%;\n    max-width: 700px;\n  }\n  \n  .ds-form-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 768px) {\n  .ds-controls {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 16px;\n  }\n  \n  .ds-filter-section {\n    min-width: auto;\n  }\n  \n  .ds-create-main-btn {\n    width: 100%;\n    text-align: center;\n  }\n  \n  .ds-table {\n    display: block;\n    overflow-x: auto;\n  }\n  \n  .ds-action-buttons {\n    flex-direction: column;\n    gap: 6px;\n  }\n  \n  .ds-download-btn,\n  .ds-delete-btn {\n    width: 100%;\n    text-align: center;\n  }\n  \n  .ds-modal-container {\n    width: 98%;\n    margin: 10px;\n  }\n  \n  .ds-modal-header {\n    padding: 20px 20px 16px;\n  }\n  \n  .ds-modal-content {\n    padding: 20px;\n  }\n  \n  .ds-form-section {\n    padding: 16px;\n  }\n  \n  .ds-modal-footer {\n    flex-direction: column;\n    gap: 12px;\n  }\n  \n  .ds-cancel-btn,\n  .ds-create-btn {\n    width: 100%;\n    text-align: center;\n  }\n}\n\n@media (max-width: 480px) {\n  .ds-table th,\n  .ds-table td {\n    padding: 12px 8px;\n    font-size: 12px;\n  }\n  \n  .ds-modal-header h3 {\n    font-size: 18px;\n  }\n  \n  .ds-form-section h4 {\n    font-size: 14px;\n  }\n  \n  .ds-input,\n  .ds-textarea,\n  .ds-select {\n    padding: 10px 12px;\n    font-size: 13px;\n  }\n}\n\n/* Улучшенная доступность */\n@media (prefers-reduced-motion: reduce) {\n  .ds-create-main-btn,\n  .ds-create-btn,\n  .ds-download-btn,\n  .ds-delete-btn,\n  .ds-modal-close,\n  .ds-cancel-btn,\n  .ds-refresh-btn,\n  .ds-input,\n  .ds-textarea,\n  .ds-select,\n  .ds-form-section,\n  .ds-modal-container,\n  .ds-modal-overlay {\n    transition: none;\n    animation: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
